<template lang="html">
    <div class="baseInfo">
        <div class="imgBox">
            <!-- <img :src="detail.service_icon"> -->
            <QualityImg :src="detail.service_icon" width="250" height="250" />
        </div>
        <div class="info">
            <p class="name">{{ detail.service_name }}</p>
            <div class="priceBox">
                <span class="price"><i class="flag">￥</i>{{ detail.service_price }}</span>
                <span class="discountPrice" v-if="Number(detail.original_price) !== 0">￥{{ detail.original_price }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import QualityImg from '@/components/qualityImg/qualityImg.vue'
export default {
    name: 'storeInfo',
    props: {
        /* 服务详情数据 */
        detail : {
            type: Object,
            default () {
                return {}
            }
        }
    },
    components: {
        QualityImg
    },
    data () {
        return {
            tabActive: 0
        }
    },
    methods: {
        findPosition () {

        },
        handleCallPhone () {

        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
.baseInfo
    padding 30px
    display flex
    .imgBox
        border 1px solid #efefef
        width 250px
        height 250px
        margin-right 36px
        img
            width 250px
            height 250px
    .info
        flex 1
        .name
            font-size 30px
            line-height 36px
            color #3b3b3b
            mutiLineTextOverFlow()
        .priceBox
            margin 30px 0
            .price
                font-size 40px
                line-height 40px
                color #fc2d2d
                .flag
                    font-size 24px
                    font-style normal
            .discountPrice
                font-size 24px
                line-height 30px
                color #999999
                text-decoration line-through
                margin 0 20px
</style>
